export const PRIVACY_POLICY_URL = 'https://www.georgia-app.com/privacy-policy'
export const TERMS_OF_USE_URL = 'https://www.georgia-app.com/terms-of-use'
